import {RlMediaStream} from "./RlMediaStream";

// TODO: gesture user must be fixed

export class RlAudioStream extends RlMediaStream {
    /** @internal */
    private _trackEl: HTMLAudioElement | undefined;

    /**
     * Play received audio in background if you want play it automatically
     * @constructor
     */
    public Play() {
        this._trackEl = new Audio();
        this._trackEl.srcObject = this.Stream;
        this._trackEl.autoplay = true;

        this._trackEl.play();
    }


    /**
     * Automatically stops when stream closed from server
     * @constructor
     */
    public Stop() {
        if (!this._trackEl) return;

        this._trackEl.srcObject = null;
        this._trackEl.autoplay = false;
        this._trackEl = undefined;
    }
}